import React from 'react'
import { Whisper, Tooltip } from 'rsuite'
import { Cell } from 'rsuite-table'
import './RoleCell.scss'

type RoleConfig = {
  label: string
  className: string
}

type RoleCellProps = {
  rowData?: Record<string, any>
  dataKey: string
  roleMap?: Record<string, RoleConfig>
}

const defaultRoleMap: Record<string, RoleConfig> = {
  admin: { label: 'Admin', className: 'role-cell--admin' },
  moderator: { label: 'Moderator', className: 'role-cell--moderator' },
  agent: { label: 'Agent', className: 'role-cell--agent' },
  user: { label: 'User', className: 'role-cell--user' },
  internal_user: {
    label: 'Internal User',
    className: 'role-cell--internal-user'
  },
  none: { label: 'No Role', className: 'role-cell--none' }
}

const resolveRole = (value: unknown): string => {
  if (typeof value === 'string') return value.toLowerCase()
  if (Array.isArray(value) && value.length > 0) {
    const first = value[0]
    const name =
      typeof first === 'string' ? first : first?.name ?? first?.code ?? ''
    return name.replace(/^ROLE_/i, '').toLowerCase()
  }
  return 'none'
}

const RoleCell: React.FC<RoleCellProps> = ({
  rowData,
  dataKey,
  roleMap = defaultRoleMap,
  ...props
}) => {
  const rawValue = rowData?.[dataKey]
  const roleValue = resolveRole(rawValue)
  const config = roleMap[roleValue] ?? {
    label: roleValue || 'none',
    className: 'role-cell--none'
  }

  return (
    <Whisper
      placement="bottom"
      trigger="hover"
      speaker={<Tooltip>{config.label}</Tooltip>}
    >
      <Cell {...props}>
        <span className={`role-cell ${config.className}`}>{config.label}</span>
      </Cell>
    </Whisper>
  )
}

export default RoleCell
